import { OlliUrl, CorporateEducationUrl, InternationalProgramsUrl, StudentServicesUrl, NewsUrl, ProgramsUrl } from "../directives/utilities/urls";

export default function searchList() {
    return {
        searchList: [],
        tempSearchList: [],
        totalCount: 0,
        pageCount: 0,
        currentPage: 1,
        hasMore: false,
        currentPageURLPart: "",
        keywords: '',
        labelkeywords: '',
        path: '/%',
        activeClassFor: 'All',
        isKeyword: false,
        errorisKeyword: '',
        isSearchedData: false,
        errorisSearchedData: 'No data found',
        seasonList: [],
        passedAcademicTerm: '',
        passedAcademicYear: '',
        coursesList: [],
        headerSearchVal: '',
        isCoursesClick: false,
        isCMSPageClick: false,
        showLoader: false,
        currentPageURLPartName() {
            // Get the current URL
            var currentURL = window.location.href;
            // Extract the part after the last '/'
            var parts = currentURL.split("/");
            var value = parts[parts.length - 1];

           this.currentPageURLPart = value;
           
            return this.currentPageURLPart;
        },
        paginate(pageNumber) {
            this.currentPage = pageNumber;
            this.bindSearchList();
        },
        prev() {
            this.currentPage = this.currentPage - 1;
            this.bindSearchList();
        },
        next() {
            this.currentPage = this.currentPage + 1;
            if (this.isCoursesClick == false && this.isCMSPageClick == true || this.headerSearchVal !="") {
                this.bindSearchList();
            }
            if (this.isCoursesClick == true && this.isCMSPageClick == false) { 
                this.bindCoursesList();
            }
        },
        formatContent(description) {
            if (description.length > 200) {
                return description.substring(0, 200) + '...';
            } else {
                return description;
            }
        },
        searchClick() {
            this.isCoursesClick = false;
            this.isCMSPageClick = true;
            this.headerSearchVal = "";
            this.coursesList = [];
            if (this.keywords == "") {
                this.isKeyword = false;
                this.errorisKeyword = "Please enter text to search";
            }
            else {
                this.isKeyword = true;
            }
            this.path = "/%";
            this.activeClassFor = "All";
            this.labelkeywords = this.keywords;
            this.searchList = [];
            this.currentPage = 1;
            document.getElementById('hiddenSearchKeyWord').value = this.keywords;
            //this.isSearchedData = true;
            this.bindSearchList();
        },
        programsClick() {
            this.isCoursesClick = false;
            this.isCMSPageClick = true;
            this.coursesList = [];
            if (this.keywords == "") {
                this.isKeyword = false;
                this.errorisKeyword = "Please enter text to search";
            }
            else {
                this.isKeyword = true;
            }
            this.activeClassFor = "Programs";
            this.path = ProgramsUrl;
            this.labelkeywords = this.keywords;
            this.searchList = [];
            this.currentPage = 1;
            this.headerSearchVal = "";
            //this.isSearchedData = true;
            this.bindSearchList();
        },
        coursesClick() {
            this.isCoursesClick = true;
            this.isCMSPageClick = false;
            if (this.isCoursesClick == true && this.isCMSPageClick == false) {
                this.searchList = [];
                this.coursesList = [];
            }
            this.headerSearchVal = "";
            this.hasMore = false;
            this.activeClassFor = "Courses";
            this.labelkeywords = this.keywords;
            if (this.keywords == "") {
                this.isKeyword = false;
                this.errorisKeyword = "Please enter text to search";
            }
            else {
                this.isKeyword = true;
            }
            this.currentPage = 1;
            this.bindCoursesList();
        },
        bindCoursesList() {
            this.showLoader = true;
            if (this.isKeyword == true) {
                for (let i = 0; i < this.seasonList.length; i++) {
                    fetch("/api/ProgramAPI/GetCourseSearch", {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            AcademicYear: this.seasonList[i].academicYear,

                            AcademicTerm: this.seasonList[i].academicTerm,

                            DeliveryMode: "",
                            CategoryID: "",
                            CourseLength: 50,
                            CreditType: 0,
                            PageSize: 10,
                            PageNumber: this.currentPage,
                            Keyword: this.keywords,
                        })
                    })
                        .then((response) => {
                            return response.json();
                        })
                        .then((response) => {
                            this.showLoader = false;
                            if (response != undefined && response.isSuccess) {
                                //if (isSearchCall) {
                                //this.coursesList = response.courses;
                                //} else {
                                Array.prototype.push.apply(this.coursesList, response.courses);
                                //}
                                this.hasMore = response.hasMore;
                                this.isSearchedData =
                                    this.coursesList.length <= 0 ? true : false;
                                this.errorisSearchedData = this.coursesList.length <= 0 ? "No data found" : "";
                            } else {
                                this.errorisSearchedData = "An unknown error has occurred. Please try again later.";
                            }
                        });
                }
            }
            else {
                this.isSearchedData = false;
                this.hasMore = false;
                this.showLoader = false;
            }
        },
        internationalClick() {
            this.isCoursesClick = false;
            this.isCMSPageClick = true;
            this.coursesList = [];
            if (this.keywords == "") {
                this.isKeyword = false;
                this.errorisKeyword = "Please enter text to search";
            }
            else {
                this.isKeyword = true;
            }
            this.activeClassFor = "InternationalPrograms";
            this.path = InternationalProgramsUrl;
            this.labelkeywords = this.keywords;
            this.searchList = [];
            this.currentPage = 1;
            this.headerSearchVal = "";
            //this.isSearchedData = true;
            this.bindSearchList();
        },
        corporateEducationClick() {
            this.isCoursesClick = false;
            this.isCMSPageClick = true;
            this.coursesList = [];
            if (this.keywords == "") {
                this.isKeyword = false;
                this.errorisKeyword = "Please enter text to search";
            }
            else {
                this.isKeyword = true;
            }
            this.activeClassFor = "CorporateEducation";
            this.path = CorporateEducationUrl;
            this.labelkeywords = this.keywords;
            this.searchList = [];
            this.currentPage = 1;
            this.headerSearchVal = "";
            //this.isSearchedData = true;
            this.bindSearchList();
        },
        oLLIClick() {
            this.isCoursesClick = false;
            this.isCMSPageClick = true;
            this.coursesList = [];
            if (this.keywords == "") {
                this.isKeyword = false;
                this.errorisKeyword = "Please enter text to search";
            }
            else {
                this.isKeyword = true;
            }
            this.activeClassFor = "OLLI";
            this.path = OlliUrl;
            this.labelkeywords = this.keywords;
            this.searchList = [];
            this.currentPage = 1;
            this.headerSearchVal = "";
            //this.isSearchedData = true;
            this.bindSearchList();
        },
        studentServicesClick() {
            this.isCoursesClick = false;
            this.isCMSPageClick = true;
            this.coursesList = [];
            if (this.keywords == "") {
                this.isKeyword = false;
                this.errorisKeyword = "Please enter text to search";
            }
            else {
                this.isKeyword = true;
            }
            this.activeClassFor = "StudentServices";
            this.path = StudentServicesUrl;
            this.labelkeywords = this.keywords;
            this.searchList = [];
            this.currentPage = 1;
            this.headerSearchVal = "";
            //this.isSearchedData = true;
            this.bindSearchList();
        },
        newsClick() {
            this.isCoursesClick = false;
            this.isCMSPageClick = true;
            this.coursesList = [];
            if (this.keywords == "") {
                this.isKeyword = false;
                this.errorisKeyword = "Please enter text to search";
            }
            else {
                this.isKeyword = true;
            }
            this.activeClassFor = "news";
            this.path = NewsUrl;
            this.labelkeywords = this.keywords;
            this.searchList = [];
            this.currentPage = 1;
            this.headerSearchVal = "";
            //this.isSearchedData = true;
            this.bindSearchList();
        },
        bindSeasonList() {

            fetch('/api/ProgramAPI/GetSeasonList?top=' + 2, { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        Array.prototype.push.apply(this.seasonList, response.seasons)
                        
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
        bindSearchList() {
            this.showLoader = true;
            this.isSearchedData = false;
            if (this.isKeyword == true) {
                var pageSize = 10;
                //this.keywords = this.headerSearchVal ? this.headerSearchVal:this.keywords;
                fetch(
                    "/api/Search/GetSearchedPages?keywords=" +
                    this.keywords +
                    "&path=" +
                    this.path +
                    "&headerSearchTextVal=" +
                    this.keywords+
                    "&pageSize=" +
                    pageSize +
                    "&pageNumber=" +
                    this.currentPage,
                    { method: "GET" }
                )
                    .then((response) => {
                        if (response.ok) {
                            return response.json();
                        }
                    })
                    .then((response) => {
                        this.showLoader = false;
                        Array.prototype.push.apply( this.searchList, response.searchList );
                        this.hasMore = response.hasMore;
                        this.isSearchedData = this.searchList.length <= 0 ? true : false;
                        this.errorisSearchedData = this.searchList.length <= 0 ? "No data found" : "";
                        document.getElementById("loadMoreButton").focus();
                    });
            }
            else {
                this.showLoader = false;
                this.isSearchedData = false;
                this.hasMore = false;
               
            }
        },
      
        init() {
          
            this.headerSearchVal = document.getElementById('hiddenSearchKeyWord').value;
            this.keywords = this.headerSearchVal ? this.headerSearchVal : this.keywords;
            this.labelkeywords = this.keywords;
            this.isKeyword = this.headerSearchVal ? true : false;
            this.activeClassFor = this.activeClassFor;
            this.bindSeasonList();
            this.bindSearchList();
        },
    };
}
